import SpriteSymbol from "../../../../../../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-development",
  "use": "app-development-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 30\" id=\"app-development\"><path fill=\"var(--bolt-theme-icon, currentColor)\" fill-rule=\"evenodd\" d=\"M28 8H2V3a1 1 0 011-1h24a1 1 0 011 1zm0 19a1 1 0 01-1 1H3a1 1 0 01-1-1V10h26zm1-27H1a1 1 0 00-1 1v28a1 1 0 001 1h28a1 1 0 001-1V1a1 1 0 00-1-1zM8 6h2V4H8zm4 0h2V4h-2zM4 6h2V4H4zm10 18h2v-4h4v-2h-4v-4h-2v4h-4v2h4z\" data-name=\"Page-1\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol